export default __webpack_public_path__ + "static/media/chile.379d737b.svg";